import { render } from "./readfile.vue?vue&type=template&id=b59cf532"
import script from "./readfile.vue?vue&type=script&lang=js"
export * from "./readfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__